export default {
  beforeCreate(context, inject) {
    var gf = {
      initKV: function (t, k, rs) {
        context.$axios.get(`/api/u/settings/r/${k}/list`, {
          json: true,
          validateStatus: function (status) {
            return status >= 200 && status < 404; // default
          }
        }).then(
          res => {
            console.log("initKV k: ", res);
            if (res.data && res.data.status === "success")
              res.data.result.forEach(item => {
                if (k === "business_area") {
                  rs.push({
                    cate: item.KeyName,
                    keyName: item.KeyValue,
                    keyValue: item.KeyValue,
                    disabled: false
                  })
                } else {
                  rs.push({
                    keyName: item.KeyValue,
                    keyValue: item.KeyName,
                    disabled: false
                  })
                }
              });
            console.log(rs);
          }
        );
      },
      uuid: function () {
        if (process.server) {
          return context.req.cookies.uuid;
        } else {
          return require('js-cookie').get('uuid');
          // ua = navigator.userAgent;
        }
      },
      sysParam: function (lang, key) {
        var sysParams;
        try {
          if (process.server) {
            sysParams = JSON.parse(context.req.cookies.sysParams);
          } else {
            sysParams = JSON.parse(require('js-cookie').get('sysParams'));
            // ua = navigator.userAgent;
          }
        } catch (e) {
          console.log(e);
          return "";
        };
        // console.log("sysParams: ", sysParams);
        if (sysParams && sysParams[lang] && sysParams[lang][key]) {
          return sysParams[lang][key];
        }
        return ""
      },
      factoryNames: function () {
        var names = [];
        if (process.server) {
          try {
            names = JSON.parse(context.req.cookies.factory_names);
          } catch (e) {
            console.log(e);
          };
        } else {
          names = JSON.parse(require('js-cookie').get('factory_names'));
          // ua = navigator.userAgent;
        }
        return names;
      },
      userId: function () {
        if (process.server) {
          return context.req.cookies.user_id;
        } else {
          return require('js-cookie').get('user_id');
          // ua = navigator.userAgent;
        }
      },
      getAllCountries: function () {
        var rawData = require('./data.json');
        return rawData.countries;
      },

      getAllTimezones: function () {
        var rawData = require('./data.json');
        return rawData.timezones;
      },

      getTimezonesForCountry: function (countryId) {
        var countries = this.getAllCountries();
        var timezones = this.getAllTimezones();
        var timezoneIds = (countries[countryId] || {}).timezones || [];
        return timezoneIds.map(function (timezoneId) {
          return timezones[timezoneId];
        });
      },

      getCountriesForTimezone: function (timezoneId) {
        var countries = this.getAllCountries();
        var timezones = this.getAllTimezones();
        var countryIds = (timezones[timezoneId] || {}).countries || [];
        return countryIds.map(function (countryId) {
          return countries[countryId];
        });
      },
      convertUTCDateToLocalDate: function (sd) {
        // var d = Date.parse(sd);
        // console.log(d);
        // var newDate = new Date(sd);
        // var offset = newDate.getTimezoneOffset() / 60;
        // var hours = newDate.getHours();
        // newDate.setHours(hours + offset);
        // return newDate.toLocaleString(); 
        // return require("moment")(sd).local().format("YYYY-MM-DD HH:mm:ss");
        var moment = require("moment");
        var cTimezones = [];
        try {
          // const ct = require('country-timezone');
          var clc = "CN";
          if (this.lang() === "en") {
            clc = "UK";
          }
          var cc = this.ucountry() || clc;
          // console.log(clc);
          console.log("ucountry: ", cc);
          // cc = "CN";
          cTimezones = this.getTimezonesForCountry(cc);
          console.log("cTimezones: ", cTimezones);

        } catch (error) {
          console.log("convertUTCDateToLocalDate: ", error);
        }
        if (this.lang() === "en" && ((cTimezones && cTimezones.length < 1) || cTimezones === undefined)) {
          return moment(sd).format("YYYY-MM-DD HH:mm:ss") + "[UTC]";
        }
        if (this.lang() !== "en" && ((cTimezones && cTimezones.length < 1) || cTimezones === undefined)) {
          return moment(sd).utcOffset('+8:00').format("YYYY-MM-DD HH:mm:ss") + "[北京时间]";
        }
        return moment(sd).utcOffset(cTimezones[0].offsetStr).format("YYYY-MM-DD HH:mm:ss") + "[" + cTimezones[0].name + "]";
      },
      token: function () {
        if (process.server) {
          return context.req.cookies.token;
        } else {
          return require('js-cookie').get('token');
          // ua = navigator.userAgent;
        }
      },
      ucountry: function () {
        if (process.server) {
          return context.req.cookies.country;
        } else {
          return require('js-cookie').get('country');
          // ua = navigator.userAgent;
        }
      },
      lang: function () {
        if (process.server) {
          return context.req.cookies.lang;
        } else {
          return require('js-cookie').get('lang');
          // ua = navigator.userAgent;
        }
      }
    };
    // Inject httpClient eveywhere
    inject('gf', gf);

    // You can use it everywhere in your app:
    // - In UVue context: `context.$gf`
    // - In your components: `this.$gf`
    // - In your store actions: `this.$gf`
  },
};